module.exports = __webpack_public_path__ + "media/images/iconSettings__inactive-454d83de85b6080695220919cff611bb.png";